// removed by extract-text-webpack-plugin
module.exports = {"upgradeNotificationContainer":"EcommercePrompt-upgradeNotificationContainer","prompt":"EcommercePrompt-prompt"};